import {
  PRODUCT_SELECTED_DATA,
  INSTANCE_SELECTED_DATA,
  GLOBAL_SELECTED_PRODUCT_DATA,
  GLOBAL_CHATBOT_ID_DATA,
  GLOBAL_AUTHORAI_ID,
  GLOBAL_ASK_YOUR_DATA_ID,
  GLOBAL_DATE_TYPE_DATA,
  GLOBAL_START_DATE,
  GLOBAL_END_DATE,
  GLOBAL_ROUTES_UPDATE,
  DASHBOARD_TAB_UPDATE,
  PRODUCT_TAB_UPDATE,
  KBUTILITY_CHATBOT,
  DESIGNATION_UPDATE,
  USERS_UPDTAE,
  REPORT_TYPE_UPDATE,
  TASKPDF_CHAT_UPDATE,
  SITE_UPDATE,
  TEAM_TYPE_UPDATE,
  SELECTED_PLATFORM,
  DOCKER_STATUS_CHECK,
  PROMPT_AI_SELECTED_INSTANCE,
  NO_INSTANCE_FOR_PRODUCT,
  SELECTED_MODULE_OPEN_SIDEBAR_PANEL,
  SET_IS_STREAMING,
  ACTIVE_MENU_DETAILS,
  SET_DASHBOARD_FILTERS,
  BACK_ROUTER_PATH,
  NAVIGATION_THEME,
  USER_ALL_ROUTES_CLICK_DATA 
} from '../../common/actionTypes';
import { ACTIVATE_BCP_DETAILS } from '../../common/actionTypes.js';
import { DASHBOARD, ColorTheme} from '../../common/constants/constants.js';

const INITIAL_STATE = {
  productSelectedData: null,
  instanceSelectedData: null,
  globalChatbotID: null,
  globalAuthorAIID: null,
  globalAskYourDataID: null,
  globalDateType: null,
  globalStartDate: null,
  globalEndDate: null,
  previousRoute: null,
  dashboardTab: DASHBOARD.Overview,
  productTab: null,
  kbutilityChatbot: null,
  designations: null,
  userIds: ['1'],
  reportType: null,
  taskPdfCurrentChat: null,
  sitesId: [],
  team_type: null,
  dockerStatus: false,
  taskscribedockerStatus: false,
  promptAISelectedInstance: {},
  noInstance: false,
  selectedModuleOpenSidebarPanel: {},
  isStreaming: false,
  activeMenuDetails: {},
  activateBCPDetails: false,
  dashboardFilters: [],
  backRouterPath: '',
  navigationTheme: ColorTheme?.LIGHT_MODE,
  userAllRoutesClickData:[],
};

const GlobalDataReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case PRODUCT_SELECTED_DATA: {
      // console.log('# PRODUCT_SELECTED_DATA # ', action.payload);

      return { ...state, productSelectedData: action.payload }; // this is a new state which hold selected product name based on privilage (will match through display name but storing whole object)
    }
    case INSTANCE_SELECTED_DATA: {
      // console.log('$ INSTANCE_SELECTED_DATA $ ', action.payload);

      return { ...state, instanceSelectedData: action.payload }; // this is a new state which hold selected instance name based on privilage (will match through display name but storing whole object)
    }
    case GLOBAL_SELECTED_PRODUCT_DATA: {
      return {
        ...state,
        globalSelectedProduct: action.payload
      };
    }
    case GLOBAL_CHATBOT_ID_DATA: {
      return {
        ...state,
        globalChatbotID: action.payload,
      };
    }
    case GLOBAL_AUTHORAI_ID: {
      return {
        ...state,
        globalAuthorAIID: action.payload,

      };
    }
    case GLOBAL_ASK_YOUR_DATA_ID: {
      return {
        ...state,
        globalAskYourDataID: action.payload,

      };
    }
    case GLOBAL_DATE_TYPE_DATA: {
      return {
        ...state,
        globalDateType: action.payload,
      };
    }
    case GLOBAL_START_DATE: {

      return { ...state, globalStartDate: action.payload };
    }
    case GLOBAL_END_DATE: {

      return { ...state, globalEndDate: action.payload };
    }
    case GLOBAL_ROUTES_UPDATE: {
      return { ...state, previousRoute: action.payload };
    }
    case DASHBOARD_TAB_UPDATE: {
      return { ...state, dashboardTab: action.payload };
    }
    case PRODUCT_TAB_UPDATE: {
      return { ...state, productTab: action.payload };
    }
    case KBUTILITY_CHATBOT: {
      return { ...state, kbutilityChatbot: action.payload };
    }
    case DESIGNATION_UPDATE: {
      return { ...state, designations: action.payload };
    }
    case USERS_UPDTAE: {
      return { ...state, userIds: action.payload };
    }
    case REPORT_TYPE_UPDATE: {
      return { ...state, reportType: action.payload };
    }
    case TASKPDF_CHAT_UPDATE: {
      return { ...state, taskPdfCurrentChat: action.payload };
    }
    case SITE_UPDATE: {
      return { ...state, sitesId: action.payload };
    }
    case TEAM_TYPE_UPDATE: {
      return { ...state, team_type: action.payload };
    }
    case SELECTED_PLATFORM: {
      return { ...state, selectedPlatform: action.payload };
    }
    case DOCKER_STATUS_CHECK: {
      return { ...state, dockerStatus: action.payload };
    }
    case PROMPT_AI_SELECTED_INSTANCE: {
      return { ...state, promptAISelectedInstance: action.payload };
    }
    case NO_INSTANCE_FOR_PRODUCT: {
      return { ...state, noInstance: action.payload };
    }
    case SELECTED_MODULE_OPEN_SIDEBAR_PANEL: {
      return { ...state, selectedModuleOpenSidebarPanel: action.payload };
    }
    case SET_IS_STREAMING: {
      return { ...state, isStreaming: action.payload };
    }
    case ACTIVE_MENU_DETAILS: {
      return { ...state, activeMenuDetails: action.payload };
    }
    case ACTIVATE_BCP_DETAILS: {
      return { ...state, activateBCPDetails: action.payload };
    }
    case BACK_ROUTER_PATH: {
      return { ...state, backRouterPath: action.payload };
    }
    case NAVIGATION_THEME: {            
      return { ...state, navigationTheme: action.payload };
    }
    case USER_ALL_ROUTES_CLICK_DATA: {            
      return { ...state, userAllRoutesClickData: action.payload };
    }
    default:
      return state;
  }
};

export default GlobalDataReducer;
